<div class="table-scroller">
  @if (config(); as templateData) {
    <table class="data-table" role="table" [attr.aria-label]="templateData.ariaLabel">
      @if (templateData.caption) {
        <caption class="visually-hidden">
          {{
            templateData.caption
          }}
        </caption>
      }
      @if (templateData.headers; as headers) {
        @if (headers.length > 0) {
          <thead>
            <tr>
              @for (cell of headers; track $index) {
                <th scope="col">
                  <div class="cell-flex">
                    @if (cell) {
                      <span class="mat-body-medium">{{ cell }}</span>
                    }
                  </div>
                </th>
              }
            </tr>
          </thead>
        }
      }
      @if (templateData.rows; as rows) {
        @if (rows.length > 0) {
          <tbody>
            @for (row of rows; track $index) {
              <tr>
                @for (cell of row; track $index) {
                  <td>
                    <div class="cell-flex">
                      @if (cell) {
                        <span class="mat-body-medium">{{ cell }}</span>
                      }
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
        }
      }
      @if (templateData.footers; as footers) {
        @if (footers.length > 0) {
          <tfoot>
            <tr>
              @for (cell of footers; track $index) {
                @if ($index === 0) {
                  <th scope="row">
                    <div class="cell-flex">
                      @if (cell) {
                        <span class="mat-body-medium">{{ cell }}</span>
                      }
                    </div>
                  </th>
                } @else {
                  <td>
                    <div class="cell-flex">
                      @if (cell) {
                        <span class="mat-body-medium">{{ cell }}</span>
                      }
                    </div>
                  </td>
                }
              }
            </tr>
          </tfoot>
        }
      }
    </table>
  }
</div>
